import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IsPeriodNavigatorService {

  // Parameters coming from the form selection
  private selectedDate: any;
  public selectedFrequency: string;
  public selectedAggregation: string;

  // [ "from", "to" ] value that will be used to set queryparameters. Initialized to current day
  public parsedDate = new Subject<[string, string]>();

  constructor(
    private _translateService: TranslateService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit(): void {
  }

  public getFrequency(): string {
    return this.selectedFrequency;
  }

  public getAggregation(): string {
    return this.selectedAggregation;
  }

  public setFrequency(frequency): void {
    this.selectedFrequency = frequency;
  }

  public setDate(date: Date, frequency: string, aggregation?: string): void {
    this.selectedDate = date;
    this.selectedFrequency = frequency;
    if (aggregation) {
      this.selectedAggregation = aggregation;
    }

    this.setParsedDate();
  }

  private setParsedDate(): void {
    // Temporary variable that will store the "next" value of the observable
    const tempDate: [string, string] = ['', ''];

    // TODO: align with period navigator in data experience - fix time zone
    // Parses "from" and "to" depending on the selected frequency
    if (this.selectedFrequency === 'daily') {
      tempDate[0] = moment(this.selectedDate).utc(true).startOf('day').format();
      tempDate[1] = moment(this.selectedDate).add(1, 'days').utc(true).startOf('day').format();
    } else if (this.selectedFrequency === 'weekly') {
      const dayOfMonth = this.selectedDate.getDate();
      const dayOfWeek = this.selectedDate.getDay();
      const firstDayOfWeekNum = dayOfMonth - dayOfWeek + (dayOfWeek == 0 ? -6 : +1);
      const firstDayOfWeek = new Date(this.selectedDate.setDate(firstDayOfWeekNum));

      tempDate[0] = moment(firstDayOfWeek).utc(true).startOf('day').format();
      tempDate[1] = moment(firstDayOfWeek).add(1, 'week').utc(true).startOf('day').format();
    } else if (this.selectedFrequency === 'monthly') {
      const selectedMonth = this.selectedDate.getMonth();
      const selectedYear = this.selectedDate.getFullYear();

      const firstDay = new Date(selectedYear, selectedMonth, 1);
      const lastDay = new Date(selectedYear, selectedMonth + 1, 0);

      tempDate[0] = moment(firstDay).utc(true).startOf('day').format();
      tempDate[1] = moment(lastDay).add(1, 'days').utc(true).startOf('day').format();

    } else if (this.selectedFrequency === 'yearly') {
      const selectedYear = this.selectedDate.getFullYear();

      const firstDay = new Date(selectedYear, 0);
      const lastDay = new Date(selectedYear + 1, -1, 31);

      tempDate[0] = moment(firstDay).utc(true).startOf('day').format();
      tempDate[1] = moment(lastDay).add(1, 'days').startOf('day').utc(true).format();

    } else if (this.selectedFrequency === 'personalized') {
      if (this.selectedDate?.start && this.selectedDate?.end) {
        tempDate[0] = moment(this.selectedDate?.start).startOf('day').utc(true).format();
        tempDate[1] = moment(this.selectedDate?.end).startOf('day').utc(true).format();
      } else {
        tempDate[0] = moment(this.selectedDate).utc(true).startOf('day').format();
        tempDate[1] = moment(this.selectedDate).add(1, 'days').startOf('day').utc(true).format();
      }
    }
    // Updates the observable
    this.parsedDate.next(tempDate);
  }

  public setRangeParsedDate(range): void {
    // Temporary variable that will store the "next" value of the observable
    const tempDate: [string, string] = ['', ''];
    tempDate[0] = moment(range.start).utc(true).format();
    // tempDate[1] = moment(range.end).add(1, 'days').utc(true).format();
    tempDate[1] = moment(range.end).utc(true).format();

    // Updates the observable
    this.parsedDate.next(tempDate);
  }

  public getParsedDate() {
    return this.parsedDate;
  }
}
